import * as actions from '../actions/user';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import { push } from 'connected-react-router'
import {requestNotificationsIndicator} from "../actions/notifications";
import sampleCombine from "xstream/extra/sampleCombine";
import {isAragUser, isSolicitorUser} from "../helpers/functions";

export function fetchUnseenNumberOnLocationChange(sources) {
    const state$ = sources.STATE;
    const userRoles$ = state$.map(state => state.user.loggedInUser.roles);

    const request$ = sources.ACTION
        .filter(action => action.type === '@@router/LOCATION_CHANGE')
        .compose(sampleCombine(userRoles$))
        .filter(([response, userRoles]) => isAragUser(userRoles) || isSolicitorUser(userRoles))
        .map( ([response, userRoles])  => requestNotificationsIndicator() );

    return {
        ACTION: request$,
    };
}

export function redirectToSolTableAfterSolGroupDelete(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_DELETE_SOLICITOR_GROUP  )
        .map(response => push('/solicitors/solicitor-groups'));

    return {
        ACTION: request$,
    };
}

export function redirectToBaseUrlAfterSolicitorSetPassword(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_POST_USER_SET_PASSWORD  )
        .map(response => push('/'));

    return {
        ACTION: request$,
    };
}

export function redirectToBaseUrlAfterLogOut(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.LOGOUT  )
        .map(response => push('/'));

    return {
        ACTION: request$,
    };
}

export function expiredToken(sources) {
    const state$ = sources.STATE;
    const loggedInUserId$ = state$.map(state => state.user.loggedInUser.id);
    let httpResponse$ = sources.HTTP
        .select()
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .compose(sampleCombine(loggedInUserId$))
        .filter(([response ,loggedInUserId])=> response.status === 401 && loggedInUserId)
        .map(response => actions.logout());

    return {
        ACTION: httpResponse$,
    };
}

export function downloadFile(sources) {
        //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
        const request$ = sources.ACTION
            .filter(action => action.type === ActionTypes.DOWNLOAD_FILE  )
            .map(action => ({
                url: BASE_URL + '' + action.payload,
                category: 'downloadFile',
                method: 'GET',
                withCredentials: true
            }));

        // let httpResponse$ = sources.HTTP
        //     .select('getAcceptedToba')
        //     .map((response) =>
        //         response.replaceError((err) => xs.of(err))
        //     )
        //     .flatten()
        //     .filter(response => response.status === 200)
        //     .map(response => actions.receiveGetAcceptedToba(JSON.parse(response.text)))

        return {
            HTTP: request$
        };
}
